<template>
  <div class="font-weight-bold d-flex align-end">
    <span>τ0</span>
    <v-icon color="red" size="8" class="ms-1">mdi-circle</v-icon>
  </div>
</template>